module.exports = __webpack_public_path__ + "static/media/رحلات مع سائق عربي في سويسرا.22965c23.jpeg";